import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI.js'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI.js'
import ProductItemModalSF from '../../../components/finapp/vendor/ProductItemModalSF.js'
import ProductItemUpdateModalSF from '../../../components/finapp/vendor/ProductItemUpdateModalSF.js'

const ProductItemListPageUI = ({
  context,
  account,
  productItemList,
  onRefreshClick,
  createMode, updateMode,
  onCreateClick, onUpdateClick, selectedProductItem, onCancelClick, onCancelCreateItem
}) => (
  <SuperUserAccountPageUI
    context={context}
    className='pg_su_cal'
    backLink='/su/accounts'
    headerText={account && account.accountName}
    centered={!account && !productItemList}
    account={account}
    page='productItems'
  >
    {
      (!account && !productItemList) &&
      <SpinnerComponentUI />
    }
    {
      account && productItemList &&
      <div>
        <LRTableActionsUI
          location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
              <span className='g_m_left_100 g_large'><b>Product Items</b></span>
            </div>
          }
        />
        {
          productItemList.length !== 0 ? (
            <LRTableBodyUI>
              {
                productItemList.map((productItem, i) => (
                  <ProductItemRowUI
                    key={i}
                    context={context}
                    productItem={productItem}
                    onUpdateClick={onUpdateClick}
                  />
                ))
              }
            </LRTableBodyUI>
          ) : (
            <div className='g_m_top_50'>
              <EmptyListUI
                context={context}
                createEnabled={false}
                createDisabledMessageLabel='No product items'
              />
            </div>
          )
        }
      </div>
    }
    <ProductItemModalSF
      context={context}
      account={account}
      createMode={createMode}
      onCancelCreate={onCancelCreateItem}
      onRefreshClick={onRefreshClick}
    />
    <ProductItemUpdateModalSF
      context={context} account={account} updateMode={updateMode}
      onCancelClick={onCancelClick} onRefreshClick={onRefreshClick} productItemList={productItemList}
      selectedProductItem={selectedProductItem}
    />
  </SuperUserAccountPageUI>
)

const ProductItemRowUI = ({ context, productItem, onUpdateClick }) => (
  <LRTableRowUI
    context={context}
    className='g_flex_top'
    left={<RowLeftUI productItem={productItem} />}
    right={<RowRightUI productItem={productItem} onUpdateClick={onUpdateClick} />}
    rowId={productItem.productItemId}
  />
)

const RowLeftUI = ({ productItem }) => (
  <div className='g_flex_v'>
    <span className='g_small'>Category: {productItem.category ? productItem.category : 'No Category'}</span>
    <span className='g_small'>Item Name: {productItem.itemName}</span>
    <span className='g_small'>Maker: {productItem.maker}</span>
    <span className='g_small'>Price: {productItem.priceF1}</span>
    <span className='g_small'>Description: {productItem.description}</span>

  </div>
)

const RowRightUI = ({ productItem, onUpdateClick }) => (
  <div className='g_flex_v g_text_right'>
    <span className='g_m_left_50'>
      {
        <span className='icon icon-pencil g_link_2' onClick={onUpdateClick} data-product-id={productItem.productItemId} />
      }
    </span>
  </div>
)

export default ProductItemListPageUI
